var map = {
	"./calc-characterpunisher.md": [
		4369,
		4369
	],
	"./calc-framekillgenerator.md": [
		2812,
		2812
	],
	"./calc-frametrapchecker.md": [
		8767,
		8767
	],
	"./calc-frametraplister.md": [
		9053,
		9053
	],
	"./calc-movelinker.md": [
		8268,
		8268
	],
	"./calc-movepunisher.md": [
		3025,
		3025
	],
	"./calc-stringinterrupter.md": [
		3947,
		3947
	],
	"./calculators.md": [
		7299,
		7299
	],
	"./combos.md": [
		8511,
		8511
	],
	"./framedata.md": [
		9127,
		9127
	],
	"./moveslist.md": [
		496,
		496
	],
	"./settings.md": [
		2957,
		2957
	],
	"./statcompare.md": [
		5751,
		5751
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8290;
module.exports = webpackAsyncContext;